import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Edit,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  DateInput,
  ReferenceArrayInput,
  Toolbar,
  SaveButton,
  required,
  SelectArrayInput,
  FileField,
  useUpdate,
  useNotify,
  useRedirect
} from 'react-admin';

import { uploadImage } from '../../../config/services/strapi/strapi';

function PodcastEdit() {
  const [filesChanged, setFilesChanged] = useState({
    portada: false,
    audio: false,
  });

  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();

  const { id } = useParams();

  const handleSubmit = async(data: any) => {
    const token = localStorage.getItem('strapi_jwt');
    if (!token) {
      notify('No se encontró el token de autenticación', { type: 'error' });
      return;
    }

    try {
      const payload = JSON.parse(JSON.stringify(data));
      if (filesChanged.portada && data.portada?.rawFile) {
        const imageResult = await uploadImage(data.portada.rawFile, token);
        payload.portada = imageResult;
      }

      if (filesChanged.audio && data.audio?.rawFile) {
        const audioResult = await uploadImage(data.audio.rawFile, token);
        payload.audio = audioResult;
      }

      delete payload.portada.documentId;
      delete payload.audio.documentId;
      delete payload.id; // Asegurarse de no enviar el ID en el payload
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.publishedAt;
      delete payload.documentId;
      delete payload.ref;
      delete payload.data;

      update('podcasts', { data: payload, id }, {
        onSuccess: () => {
          notify('Podcast actualizado con éxito');
          redirect('list', 'podcasts');
        },
        onError: (error: any) => {
          notify(`Error al actualizar el podcast: ${error.message}`, { type: 'error' });
        },
      });
    }
    catch(error) {
      console.error('Error al procesar los datos del podcast:', error);
      notify('Error al procesar los datos del podcast', { type: 'error' });
    }
  }

  useEffect(() => {
    document.title = 'Editar Podcast';
  }, []);

  return (
    <Edit>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <FileInput
          source='portada'
          label='Imagen de Portada'
          validate={[required()]}
          onChange={() => setFilesChanged({ ...filesChanged, portada: true })}
        >
          <>
            {filesChanged.portada && <ImageField source="src" title="title" />}
            {!filesChanged.portada && <ImageField source="url" title="title" />}
          </>
        </FileInput>
        <TextInput source="titulo" validate={[required()]} />
        <DateInput source="fecha" validate={[required()]} />
        <TextInput source="autor" validate={[required()]} />
        <TextInput source="descripcion" validate={[required()]} />
        <TextInput source="slug" validate={[required()]} />
        <FileInput
          source='audio'
          label='Archivo de Audio'
          validate={[required()]}
          onChange={() => setFilesChanged({ ...filesChanged, audio: true })}
        >
          <>
            {filesChanged.audio && <FileField source="src" title="title" />}
            {!filesChanged.audio && <FileField source="url" title="title" />}
          </>
        </FileInput>
        <ReferenceArrayInput
          source='exponente_podcasts'
          reference='exponentes-podcasts'
          label='Exponentes'
        >
          <SelectArrayInput
            optionText="nombre"
            format={(value: any[]) => value?.map(v => typeof v === 'object' ? v.id : v)}
            parse={(value) => value}
          />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
}

export default PodcastEdit;